import styled from 'styled-components';
import { COLORS } from '../../utils/constants';

export const Container = styled.div`
  position: absolute;
  background-color: ${COLORS.MODAL_BACKGROUND};
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
`;
